export const CREDIT_CARD_MAX_COUNT_MAGIC_NUMBER = 5;
export const CHECKOUT_NEW_CARD_ID = 'new';
